import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LabelsDialogService} from "../../services/labels-dialog.service";
import {LabelsService} from "../../services/labels-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class labelsViewCtrl implements IController {

  labels: any;

  private filterConfig: any;
  private filteredLabels: any;

  /* @ngInject */
  constructor(private labelsDialogService: LabelsDialogService, private confirmDialogService: ConfirmDialogService, private $log, private labelsService: LabelsService) {
  }

  $onInit() {

    this.filterConfig = {
      queryString: undefined
    };
    this.filteredLabels = angular.copy(this.labels);
  };

  //////////////////////////////////////////////////////////////////////////

  // ******************************
  //        Public methods
  // ******************************

  onSearchQueryChange(query) {
    this.filterConfig.queryString = query;
    this.filteredLabels = this._getFilteredLabels(this.labels, query);
  }

  onCreateLabel($event) {
    this.labelsDialogService.create(this.labels, $event)
      .then((label) => {
        this._createLabel(label);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to create label @labelsView@onCreateLabel', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onEditLabel(label, $event) {
    this.labelsDialogService.edit(label, $event)
      .then((editedLabel) => {
        this._updateLabel(editedLabel);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to edit label @labelsView@onEditLabel', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onLabelActiveChange(label) {
    this._updateLabel(label);
  }

  // ******************************
  //        Private methods
  // ******************************

  _createLabel(label) {
    this.labelsService.createOne(label)
      .then((createdLabel) => {
        this.labels.push(createdLabel);
        this.filteredLabels = this._getFilteredLabels(this.labels, this.filterConfig.queryString);
      })
  }

  _updateLabel(label) {
    this.labelsService.updateOne(label)
      .then((updatedLabel) => {
        const labelIndex = _.findIndex(this.labels, (l: any) => {
          return l.id === label.id
        });
        if (labelIndex !== -1) {
          this.labels[labelIndex] = updatedLabel;
          this.filteredLabels = this._getFilteredLabels(this.labels, this.filterConfig.queryString);
        }
      })
  }

  _getFilteredLabels(labels, query) {
    return _.filter(labels, (l) => {
      const labelNameLowerCase = l.name.toLowerCase();
      return query ? labelNameLowerCase.includes(query.toLowerCase()) : true;
    });
  }


}

angular
  .module('bringoz.admin.labels')
  .component('labelsView', {
    bindings: {
      labels: '<'
    },
    template: require('./labels-view.html').default,
    controller: labelsViewCtrl
  });
